<div class="flex flex-col items-center gap-10 text-center px-4 py-12">
  @switch (state()) {
    @case ('busy') {
      <mat-spinner color="accent" [diameter]="100" />
    }
    @case ('info') {
      <mat-icon svgIcon="cp-info" class="!w-14 !h-14" />
    }
    @default {
      <mat-icon
        svgIcon="cp-check"
        class="!w-20 !h-20 p-3 rounded-full border-2 border-solid border-cp-primary-100 [&_path]:stroke-cp-secondary-100"
      />
    }
  }
  <div>
    <div class="font-grotesk-h5">{{ headline() }}</div>
    <div class="mt-6">{{ message() }}</div>
  </div>

  @if (showBack()) {
    <button
      mat-flat-button
      class="btn-primary-lg"
      [disabled]="backDisabled()"
      (click)="back.emit()"
    >
      Zurück
    </button>
  }
</div>
